import { useState, useEffect, useCallback } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListEmailsAction } from '@/application/actions/emails/ListEmailsAction';
import type {
  ListEmailsParams,
  ListEmailsResult,
  EmailOutboundDTO,
} from '@/domain/repositories/IEmailOutboundRepository';

const EMPTY: ListEmailsResult = { items: [], total: 0, page: 1, pageSize: 50 };

export const useEmails = (params: ListEmailsParams) => {
  const [result, setResult] = useState<ListEmailsResult>(EMPTY);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListEmailsAction>(TYPES.ListEmailsAction);
      const data = await action.execute(params);
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Error al cargar emails'));
      setResult(EMPTY);
    } finally {
      setIsLoading(false);
    }
  }, [
    params.tenantId,
    params.status,
    params.messageType,
    params.search,
    params.dateFrom,
    params.dateTo,
    params.page,
    params.pageSize,
  ]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    emails: result.items as EmailOutboundDTO[],
    total: result.total,
    page: result.page,
    pageSize: result.pageSize,
    isLoading,
    error,
    refetch: load,
  };
};
